<template>
  <div>
    <Modal :show="showModal" :showClose="true">
      <div class="card">
        <div class="card-body">
          <div>
            <div class="mb-4 text-sm">
              <h3>Run tip split report</h3>
              <p>Select a date range below to run a tip split.</p>
            </div>
            <form @submit.prevent="runReport">
              <h4>Select a date range</h4>
              <div class="row align-items-center">
                <div class="col">
                  <base-input
                    type="text"
                    placeholder="start date"
                    input-classes="form-control-alternative fw-bold dp-start"
                    v-model="dateRange"
                  />
                </div>
                <div class="col">
                  <base-input
                    type="text"
                    placeholder="end date"
                    input-classes="form-control-alternative fw-bold dp-end"
                    v-model="dateRange"
                  />
                </div>
              </div>
              <div class="mb-3">
                <span class="text-sm"> </span>
              </div>
              <div class="">
                <input
                  type="submit"
                  value="Run Report"
                  class="btn btn-primary"
                />
                <a href="#" class="ml-3 text-sm" @click.prevent="close"
                  >cancel</a
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import datepicker from "js-datepicker";
import moment from "moment";

export default {
  mounted() {
    if (!this.startDatePicker) {
      const ts = +new Date();
      this.startDatePicker = datepicker(".dp-start", {
        id: `dp-${ts}`,
        onSelect: () => {
          console.log("selection made");
        },
      });
      this.endDatePicker = datepicker(".dp-end", {
        id: `dp-${ts}`,
        onSelect: () => {
          console.log("selection made");
        },
      });
    }
  },
  components: {
    Modal,
  },
  props: ["showModal"],
  data() {
    return {
      dateRange: null,
      startDatePicker: null,
      endDatePicker: null,
    };
  },
  computed: {
    email() {
      return this.$store.state.user.attributes.email;
    },
  },
  methods: {
    open() {
      this.$emit("show");
    },
    close() {
      this.$emit("close");
    },
    async runReport() {
      const dateRange = this.startDatePicker.getRange();
      const response = await this.$store.dispatch("callAPI", {
        action: "createTipSplit",
        start: moment(dateRange.start).format("YYYY-MM-DD"),
        end: moment(dateRange.end).format("YYYY-MM-DD"),
      });

      // TODO: deal with errros
      const report = response.data.data;
      // console.log("split report", report);

      // add to the store
      this.$store.commit("addTipSplitReport", report);

      alert("report running");
      this.$emit("created", report);
      this.close();
    },
  },
};
</script>

<style lang="scss"></style>
